import { Injectable } from '@angular/core';
import { LBSErrorHandler, LBSErrorHandlerResult } from '../error-handler/error-handler';
import { LoggingService } from '../logging/logic/logging.service';
import { LocationError } from './location-errors';
import { NativeSettings, AndroidSettings, IOSSettings } from 'capacitor-native-settings';

@Injectable({
  providedIn: 'root',
})
export class LocationErrorHandler implements LBSErrorHandler {

    // Lifecycle
    constructor(
        private logger: LoggingService,
    ) {}

    public async handleError(error: Error): Promise<LBSErrorHandlerResult> {
        if (Object.values(LocationError).includes(error?.message as LocationError)) {
            return await this.getErrorHandlerResultForKey(error.message as LocationError) 
        }
        this.logger.log(this.constructor.name, "given error", error?.message, "is not of type LocationError")
        return undefined;
    }

    // Private Functions
    public async getErrorHandlerResultForKey(error: LocationError): Promise<LBSErrorHandlerResult> {
        switch(error) {
            case LocationError.LOCATION_MUST_BE_ACTIVATED:
                return {
                    alert: {
                        title: "ERROR-HANDLERS.LOCATION-ERRORS.MUST-BE-ACTIVE.TITLE",
                        subtitle: "ERROR-HANDLERS.LOCATION-ERRORS.MUST-BE-ACTIVE.SUBTITLE",
                        message: "ERROR-HANDLERS.LOCATION-ERRORS.MUST-BE-ACTIVE.MESSAGE",
                        confirm: "ERROR-HANDLERS.LOCATION-ERRORS.MUST-BE-ACTIVE.CONFIRM",
                        confirmFunc: () => {
                            this.openLocationSettings()
                        },
                        cancel: "ERROR-HANDLERS.LOCATION-ERRORS.MUST-BE-ACTIVE.CANCEL",
                        showExportLog: false
                    }
                }
            case LocationError.LOCATION_MUST_BE_ALLOWED:
                return {
                    alert: {
                        title: "ERROR-HANDLERS.LOCATION-ERRORS.MUST-BE-ALLOWED.TITLE",
                        subtitle: "ERROR-HANDLERS.LOCATION-ERRORS.MUST-BE-ALLOWED.SUBTITLE",
                        message: "ERROR-HANDLERS.LOCATION-ERRORS.MUST-BE-ALLOWED.MESSAGE",
                        confirm: "ERROR-HANDLERS.LOCATION-ERRORS.MUST-BE-ALLOWED.CONFIRM",
                        confirmFunc: () => {
                            this.openAppSettings()
                        },
                        cancel: "ERROR-HANDLERS.LOCATION-ERRORS.MUST-BE-ALLOWED.CANCEL",
                        showExportLog: false
                    }
                }
            
            default:
                this.logger.error(this.constructor.name, "Not Handled LocationError found!", error)
                return undefined
        }
    }

    private async openLocationSettings() {
        NativeSettings.open({
            optionAndroid: AndroidSettings.Location, 
            optionIOS: IOSSettings.LocationServices
        })
    }

    private async openAppSettings() {
        NativeSettings.open({
            optionAndroid: AndroidSettings.Application, 
            optionIOS: IOSSettings.App
        })
    }
}
